<template>
  <div>
    <wc-data-box
      title='Expense Line Items'
      titleIcon='mdi-view-headline'
      titleIconColor='purple'
      :showAdd='!isLoading && !expense.reconciliation && !expense.is_posted'
      @add='add'
      :loading='isLoading'
    >
      <v-simple-table dense>
        <thead>
          <tr class='overline'>
            <th class='text-left' width='180'>Division</th>
            <th class='text-left'>Description</th>
            <th class='text-left'>Account</th>
            <th class='text-right' width='100'>AMT</th>
            <th class='text-right' width='100'>GST</th>
            <th class='text-right' width='100'>TOTAL</th>
            <th width='120'></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if='lines.length === 0 && !addLine'>
            <td colspan='5'>No lines...</td>
          </tr>
          <expense-line
            v-for='l in lines'
            :key='l.id'
            :line='l'
            :expense='expense'
            :disableEdit='expense.reconciliation !== null'
            :accounts='expenseAccounts'
            :is_posted="expense.is_posted"
            @save='updateLine'
            @deleteLine='deleteLine'
          ></expense-line>
          <expense-line
            ref='blankLine'
            v-if='addLine'
            :line='lineCopy'
            :expense='expense'
            :editMode='editMode'
            :accounts='expenseAccounts'
            @save='updateLine'
            @cancelEdit='cancelAddLine'
          ></expense-line>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  </div>
</template>

<script>
import miscServices from '@/services/misc';
import accountingAPI from '@/api/accounting';
import Line from './Line';
import _ from 'lodash';

export default {
  name: 'expense-line-items',
  props: {
    expense: {
      required: true
    }
  },
  watch: {
    'expense.id' () {
      this.getData()
    }
  },
  data: () => ({
    isLoading: true,
    expenseAccounts: [],
    lines: [],
    lineCopy: {
      id: null,
      expense: null,
      budget_line_item: null,
      notes: '',
      gst: null,
      amount: null
    },
    addLine: false,
    editMode: false
  }),
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.expenseAccounts = await accountingAPI.getExpensePickerAccounts();
      if (this.expense.id) {
        let tmp = await accountingAPI.getExpenseLineItems(this.expense.id)
        this.lines = _.orderBy(tmp, 'id')
      } else {
        this.lines = []
      }
      this.resetCopy();
      this.updateTotals();
      this.isLoading = false
    },
    updateTotals(){
      let subtotal = 0;
      let gst = 0;
      let total = 0;
      this.lines.map(line => {
        console.log(line);
        subtotal += line.amount;
        gst += line.gst;
      });
  
      total = subtotal + gst;
      this.$emit('updateTotals', total, subtotal, gst);
    },
    resetCopy () {
      this.lineCopy = {}
      this.lineCopy.id = null
      this.lineCopy.expense = this.expense.id
      this.lineCopy.account = null
      this.lineCopy.description = ''
      this.lineCopy.gst = null
      this.lineCopy.amount = null
    },
    add () {
      this.resetCopy()
      this.addLine = true
      this.editMode = true
      this.$nextTick(() => {
        this.$refs.blankLine.setupEdit()
      })
    },
    cancelAddLine () {
      this.editMode = false
      this.addLine = false
    },
    async updateLine (line) {
      if (line.id) {
        let tmp = await accountingAPI.updateExpenseLineItem(line.id, line);
        this.lines = miscServices.replaceObject(this.lines, tmp);
      } else {
        const new_line = await accountingAPI.createExpenseLineItem(line);
        this.lines.push(new_line);
      }
      this.$emit('update', this.expense);
      this.addLine = false;
      this.updateTotals();
    },
    async deleteLine (line) {
      this.isLoading = true
      this.lines = miscServices.removeObject(this.lines, line)
      await accountingAPI.deleteExpenseLineItem(line.id)
      this.$emit('update', this.expense)
      this.updateTotals();
      this.isLoading = false
    },
    async deleteAllLines () {
      this.isLoading = true
      let tmpLines = _.cloneDeep(this.lines)
      for (let i = 0; i < tmpLines.length; i++) {
        await this.deleteLine(tmpLines[i])
      }
      this.lines = []
      this.updateTotals();
      this.isLoading = false
    }
  },
  components: {
    'expense-line': Line
  }
}
</script>
